<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_iv"></a><a id="Copyright">Helion &amp; Company Limited<br/>
26 Willow Road<br/>
Solihull<br/>
West Midlands<br/>
B91 1UE<br/>
England<br/>
Tel. 0121 705 3393<br/>
Fax 0121 711 4075<br/>
Email: </a><a href="mailto:info@helion.co.uk">info@helion.co.uk</a><br/>
Website: <a href="http://www.helion.co.uk" target="_blank">www.helion.co.uk</a><br/>
Twitter: @helionbooks<br/>
Visit our blog <a href="http://blog.helion.co.uk/" target="_blank">http://blog.helion.co.uk/</a></p>
<p class="copyright3">Published by Helion &amp; Company 2015<br/>
Designed and typeset by Bookcraft Ltd, Stroud, Gloucestershire<br/>
Cover designed by Paul Hewitt, Battlefield Design (<a href="http://www.battlefield-design.co.uk" target="_blank">www.battlefield-design.co.uk</a>)<br/>
Printed by Lightning Source Limited, Milton Keynes, Buckinghamshire</p>
<p class="copyright3">Text © Vittorino del Cengio 2014<br/>
Images and hand-drawn map © Paul Martelli 2014<br/>
Other maps © Helion &amp; Company Ltd 2015</p>
<p class="copyright3">ISBN: 978-1-909982-09-3<br/>
Digital ISBN: 978-1-910777-52-7</p>
<p class="copyright3">British Library Cataloguing-in-Publication Data.<br/>
A catalogue record for this book is available from the British Library.</p>
<p class="copyright3">All rights reserved. No part of this publication may be reproduced, stored in<br/>
a retrieval system, or transmitted, in any form, or by any means, electronic,<br/>
mechanical, photocopying, recording or otherwise, without the express written<br/>
consent of Helion &amp; Company Limited.</p>
<p class="copyright3">For details of other military history titles published by Helion &amp; Company Limited<br/>
contact the above address, or visit our website: <a href="http://www.helion.co.uk" target="_blank">http://www.helion.co.uk</a>.</p>
<p class="copyright3">We always welcome receiving book proposals from prospective authors.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Copyright.vue?b857766c